module.exports = __webpack_public_path__ + "img/ennetix-users-page-maintenance-tab.8488ba6d.png";